class StickyGiftProgressBar extends HTMLElement {
  connectedCallback() {
    this.thresholdCents = parseInt(this.dataset.thresholdCents, 10) || 500000;
    this.moneyFormat = this.dataset.moneyFormat || '${{amount}}';
    this.messageEl = this.querySelector('[data-gift-bar-message]');
    this.fillEl = this.querySelector('[data-gift-bar-fill]');
    this.trackEl = this.querySelector('.sticky-gift-bar__track');

    this.refresh();
    this.bindCartEvents();
    this.bindHeightSync();
  }

  bindHeightSync() {
    this.updateHeightVar();
    window.addEventListener('resize', () => this.updateHeightVar());
    if (window.ResizeObserver) {
      new ResizeObserver(() => this.updateHeightVar()).observe(this);
    }
  }

  updateHeightVar() {
    document.documentElement.style.setProperty('--gift-bar-height', `${this.offsetHeight}px`);
  }

  bindCartEvents() {
    // Cart actions done through jQuery $.ajax / $.getJSON (cart/add.js, cart/change.js, cart.js, ...)
    if (window.jQuery) {
      window.jQuery(document).on('ajaxComplete.stickyGiftBar', (event, xhr, settings) => {
        if (settings && settings.url && settings.url.indexOf('/cart') !== -1) {
          this.refresh();
        }
      });
    }

    // Cart actions done through the native fetch API
    if (!window.__stickyGiftBarFetchPatched) {
      const originalFetch = window.fetch;
      window.fetch = (...args) => {
        const request = args[0];
        const url = typeof request === 'string' ? request : (request && request.url);
        const result = originalFetch.apply(window, args);
        if (url && url.indexOf('/cart') !== -1) {
          result.then(() => this.refreshAllBars()).catch(() => {});
        }
        return result;
      };
      window.__stickyGiftBarFetchPatched = true;
    }

    document.addEventListener('sticky-gift-bar:refresh', () => this.refresh());
  }

  refreshAllBars() {
    document.querySelectorAll('sticky-gift-progress-bar').forEach((el) => {
      if (typeof el.refresh === 'function') el.refresh();
    });
  }

  refresh() {
    fetch('/cart.js', { headers: { accept: 'application/json' } })
      .then((res) => res.json())
      .then((cart) => this.render(cart.total_price))
      .catch(() => {});
  }

  render(totalPriceCents) {
    const threshold = this.thresholdCents;
    const remaining = threshold - totalPriceCents;
    const percent = Math.min(Math.max((totalPriceCents / threshold) * 100, 0), 100);

    this.fillEl.style.width = percent + '%';
    this.trackEl.setAttribute('aria-valuenow', Math.round(percent));

    if (remaining <= 0) {
      this.classList.add('is-complete');
      this.messageEl.textContent = 'Congratulations! You’ve unlocked your free gift.';
    } else if (totalPriceCents <= 0) {
      this.classList.remove('is-complete');
      this.messageEl.textContent = `Spend ${this.formatMoney(threshold)} or more and get a free gift.`;
    } else {
      this.classList.remove('is-complete');
      this.messageEl.textContent = `${this.formatMoney(remaining)} more to get your free gift.`;
    }
  }

  formatMoney(cents) {
    if (window.Shopify && typeof Shopify.formatMoney === 'function') {
      return Shopify.formatMoney(cents, this.moneyFormat);
    }
    return (cents / 100).toFixed(2);
  }
}

window.customElements.define('sticky-gift-progress-bar', StickyGiftProgressBar);
